import { createSelector } from 'reselect'

const getMyAccountPersonalInfoErrors = state => state.myAccount.personalInfoErrors

const confirmPasswordSelector = createSelector(
	[getMyAccountPersonalInfoErrors ],
	personalInfoErrors => ({
		personalInfoErrors,
	})
)

export default confirmPasswordSelector
